'use client';

import { Box, Flex, Splitter, SplitterPanelData } from '@chakra-ui/react';

import AssistantHome from '@features/assistant/AssistantHome';
import { PersonaMode } from '@features/navigation/personaMode';
import MarketUpdateSummary from '@features/positions/MarketUpdateSummary';
import ProfitLossCard from '@features/positions/predictions/ProfitLossCard';
import Redirections from '@features/positions/Redirections';
import TransferCash from '@features/positions/TransferCash';
import { useActivePersonaMode } from 'hooks/useActivePersonaMode';

const PANELS: SplitterPanelData[] = [
  {
    id: 'home',
  },
  {
    id: 'transfer-cash',
    minSize: 20,
    maxSize: 40,
  },
];
const DEFAULT_SIZE = [70, 30];

const PositionsHomePage = () => {
  const mode = useActivePersonaMode();
  // P&L tracks hedge/prediction positions — only meaningful in Analyst mode.
  const showProfitLoss = mode === PersonaMode.Analyst;

  return (
    <Flex w="full" h="full" gap={4}>
      <Splitter.Root
        panels={PANELS}
        orientation="horizontal"
        defaultSize={DEFAULT_SIZE}
        height="full"
        width="full"
        minH={0}
      >
        <Splitter.Panel id="home">
          <AssistantHome>
            <Flex direction="column" gap={4} px={4} pb={4}>
              {showProfitLoss ? <ProfitLossCard profitLoss={1000} /> : null}
              <Redirections />
              <Box px={2}>
                <MarketUpdateSummary />
              </Box>
            </Flex>
          </AssistantHome>
        </Splitter.Panel>
        <Splitter.ResizeTrigger id="home:transfer-cash" hideBelow="lg" disabled>
          <Splitter.ResizeTriggerSeparator bg="border.light" />
        </Splitter.ResizeTrigger>
        <Splitter.Panel id="transfer-cash" hideBelow="lg">
          <TransferCash />
        </Splitter.Panel>
      </Splitter.Root>
    </Flex>
  );
};

export default PositionsHomePage;
